export default __webpack_public_path__ + "static/media/general-settings.f8b6d547.svg";